/**
 * Quick-add from Chutty product card cart icon.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

function rootUrl() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}

function cartAddUrl() {
  return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || rootUrl() + 'cart/add.js';
}

function getCartSectionIds() {
  return Array.prototype.slice
    .call(document.querySelectorAll('cart-items-component'))
    .map(function (element) {
      return element.dataset.sectionId;
    })
    .filter(Boolean);
}

function openCartDrawer() {
  var drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    drawer.open();
    return true;
  }

  if (window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.openCart === 'function') {
    window.Shopify.actions.openCart();
    return true;
  }

  return false;
}

async function refreshCart() {
  var cartItemsComponent = document.querySelector('cart-items-component');

  if (cartItemsComponent && typeof cartItemsComponent.fetchCartData === 'function') {
    await customElements.whenDefined('cart-items-component');
    return cartItemsComponent.fetchCartData();
  }

  var response = await fetch(rootUrl() + 'cart.js', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch cart');
  }

  return response.json();
}

async function addToCart(variantId, button) {
  button.classList.add('is-loading');
  button.disabled = true;

  var sectionIds = getCartSectionIds();
  var formData = new FormData();
  formData.append('id', String(variantId));
  formData.append('quantity', '1');

  if (sectionIds.length) {
    formData.append('sections', sectionIds.join(','));
  }

  var deferredEventPromise = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [
        {
          merchandiseId: String(variantId),
          quantity: 1,
        },
      ],
      promise: deferredEventPromise.promise,
    })
  );

  try {
    var response = await fetch(cartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      body: formData,
    });

    var data = await response.json();

    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Add to cart failed');
    }

    var cart = await refreshCart();

    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'chutty-product-card',
        itemCount: 1,
        sections: data.sections,
        didError: false,
      },
    });

    if (!openCartDrawer()) {
      window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || rootUrl() + 'cart';
    }
  } catch (error) {
    deferredEventPromise.reject(error);

    var card = button.closest('.chutty-product-card');
    var link = card && (card.querySelector('.chutty-product-card__link') || card.querySelector('.chutty-product-card__media-link'));
    if (link && link.href) {
      window.location.href = link.href;
    }
  } finally {
    button.classList.remove('is-loading');
    button.disabled = false;
  }
}

document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-chutty-card-add]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  var variantId = button.getAttribute('data-variant-id');
  if (!variantId) return;

  addToCart(variantId, button);
});
